export const APP_NAME = 'CrowOT';

export const APP_VERSION = import.meta.env.VITE_APP_VERSION;

const host = (value, fallback) => (value ?? fallback).replace(/\/+$/, '');

export const BASE_API_URL = host(import.meta.env.VITE_API_URL, 'https://api.crowot.com');
export const BASE_MEDIA_URL = host(import.meta.env.VITE_MEDIA_URL, 'https://media.crowot.com');
export const BASE_S3_URL = host(import.meta.env.VITE_S3_URL, 'https://s3.crowot.com');
export const BASE_SEARCH_URL = host(import.meta.env.VITE_SEARCH_URL, 'https://search.crowot.com');

export const BASE_WS_URL = import.meta.env.VITE_WS_URL ?? 'wss://ws.crowot.com';

export const DISCORD_INVITE_URL = 'https://discord.gg/dYj5sSpW75';

export const WHATSAPP_INVITE_URL = 'https://chat.whatsapp.com/HZ0aOKEHX0T0T5OZ81kSCn';

export const EMAIL_RESEND_INTERVAL = 60;

export const EMAIL_VERIFY_CODE_TTL = 600;

export const LAUNCH_DATE = '2026-10-02';

export const LAUNCH_TIME = '19:00';
